import { render, staticRenderFns } from "./TenderDocument.vue?vue&type=template&id=6fad6283&scoped=true"
import script from "./TenderDocument.vue?vue&type=script&lang=js"
export * from "./TenderDocument.vue?vue&type=script&lang=js"
import style0 from "./TenderDocument.vue?vue&type=style&index=0&id=6fad6283&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad6283",
  null
  
)

export default component.exports